import React from "react";
import "./progressBar.scss";

const ProgressBar = () => <progress className="progress-bar progress-linear-animated"/>;

export default ProgressBar;